import appSettings from "../settings/appSettings";
import { GoalRelatedData, AddGoalContributionConfig } from "../types";

export function addContribution(goalRef: string, relatedData: GoalRelatedData, requestKey: string) {
  const { ajaxUrl, action, slug } = (appSettings.addGoalContributionConfig ||
    {}) as AddGoalContributionConfig;

  const requestData = {
    action: action,
    nonce: requestKey,
    slug: slug,
    goalRef: goalRef,
    relatedData: relatedData
  };

  window.jQuery.post(ajaxUrl, requestData, function () {}, "json");
}
